<template>
    <div class="ui-content dashboard line-chart-scroll">
        <div class="chart-page">
            <v-row>
                <v-col cols="4" sm="4" class="paddintp0"></v-col>
                <v-col cols="4" sm="4" class="paddintp0">
                    <div class="chart-top-btn mr-15-top">
                        <v-btn
                            @click="updatePercentileData('batch')"
                            class="sub-btn"
                            :class="percentileType == 'batch' ? 'active' : ''"
                            outlined
                        >Batch Percentile</v-btn>
                        <v-btn
                            @click="updatePercentileData('institute')"
                            class="sub-btn"
                            :class="percentileType == 'institute' ? 'active' : ''"
                            outlined
                        >Institute percentile</v-btn>
                    </div>
                </v-col>
                <v-col cols="4" sm="4" class="paddintp0"></v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" class="paddintp0">
                    <div id="chart" class="line-chart">
                        <div class="px-4 chart-area">
                            <div id="chart-line" class="percentile-chart" v-if="series.length > 0">
                                <!-- <LineGraph :seriesData="series" :chartOptions="chartOptions" /> -->

                                <apexchart
                                    type="line"
                                    :height="250"
                                    :options="chartOptions"
                                    :series="series"
                                ></apexchart>
                            </div>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import LineGraph from "@/components/Charts/LineGraph.vue";
import moment from "moment";

export default {
    name: "ChapterStanding",
    components: {
        LineGraph
    },
    props: ["studentId"],

    mounted() {
        this.getPercentileGraphData();
    },
    computed: {
        ...mapState("userStore", ["user"])
    },
    data() {
        return {
            percentileType: "batch",
            batchSeries: [],
            instituteSeries: [],
            batchTooltip: [],
            instituteTooltip: [],
            series: [],
            chartOptions: {
                chart: {
                    id: "Percentile",
                    group: "Percentile",
                    type: "line",
                    width: "95%",
                    toolbar: {
                        show: false
                    }
                },
                colors: ["#008FFB"],
                stroke: {
                    show: true,
                    width: 2,
                    colors: ["#2698D4"]
                },
                xaxis: {
                    categories: [],
                    title: {
                        text: "Test Number"
                    }
                },
                yaxis: {
                    title: {
                        text: "Percentile"
                    },
                    tickAmount: 4,
                    min: 0,
                    max: 100
                },
                markers: {
                    size: 6,
                    fillOpacity: 1,
                    shape: "circle",
                    radius: 2,                    
                }
            }
        };
    },
    methods: {
        ...mapActions({
            getPercentileData: "resultStore/getPercentileData"
        }),
        updatePercentileData(type) {
            this.percentileType = type;
            let series = {
                name: this.percentileType == "batch" ? "Batch" : "Institute",
                data: []
            };
            series.data =
                this.percentileType == "batch"
                    ? this.batchSeries
                    : this.instituteSeries;

            this.$set(this.series, 0, series);
            this.updateTooltipData();
        },
        getPercentileGraphData() {
            let reqData = {
                student_id: this.studentId
            };
            this.$root.showLoader = true;
            this.getPercentileData(reqData)
                .then(response => {
                    this.processPercentileData(response.list);
                    this.$root.showLoader = false;
                })
                .catch(err => {
                    this.$root.showLoader = false;
                });
        },
        getFormattedDate(date) {
            return moment(date).format("MMMM DD, YYYY");
        },
        processPercentileData(list) {
            let series = {
                name: this.percentileType == "batch" ? "Batch" : "Institute",
                data: []
            };
            let xaxis = [];
            list.forEach((test, idx) => {
                xaxis.push(idx + 1);
                let batchPercentileData = {
                    perc: test.batch_percentile,
                    testName: test.test_name,
                    dateOfTest: this.getFormattedDate(test.date_answered),
                    batchRank:
                        "Rank " +
                        test.batch_rank +
                        " out of " +
                        test.total_student_batch_wise +
                        " students",
                    instituteRank:
                        "Rank " +
                        test.institute_rank +
                        " out of " +
                        test.total_student_institute_wise +
                        " students",
                    target: test.target_name
                };
                let institutePercentileData = {
                    perc: test.institute_percentile,
                    testName: test.test_name,
                    dateOfTest: test.date_answered,
                    batchRank:
                        "Rank " +
                        test.batch_rank +
                        " out of " +
                        test.total_student_batch_wise +
                        " students",
                    instituteRank:
                        "Rank " +
                        test.institute_rank +
                        " out of " +
                        test.total_student_institute_wise +
                        " students",
                    target: test.target_name
                };
                this.batchTooltip.push(batchPercentileData);
                this.instituteTooltip.push(institutePercentileData);
                this.batchSeries.push(test.batch_percentile);
                this.instituteSeries.push(test.institute_percentile);
            });
            series.data =
                this.percentileType == "batch"
                    ? this.batchSeries
                    : this.instituteSeries;
            this.$set(this.series, 0, series);
            this.updateTooltipData();
        },
        updateTooltipData() {
            let that = this;
            let tooltipData =
                this.percentileType == "batch"
                    ? this.batchTooltip
                    : this.instituteTooltip;
            let tooltip = {
                followCursor: true,
                custom: function({ series, seriesIndex, dataPointIndex, w }) {
                    return (
                        "<div class='question-tooltip'>" +
                        "<span>" +
                        "<br> Percentile: " +
                        tooltipData[dataPointIndex].perc +
                        "<br> Test Name: " +
                        tooltipData[dataPointIndex].testName +
                        "<br> Date: " +
                        tooltipData[dataPointIndex].dateOfTest +
                        "<br> Batch Rank: " +
                        tooltipData[dataPointIndex].batchRank +
                        "<br> Institute Rank: " +
                        tooltipData[dataPointIndex].instituteRank +
                        "<br> Target: " +
                        tooltipData[dataPointIndex].target +
                        "</span>" +
                        "</div>"
                    );
                }
            };
            this.chartOptions = {
                ...this.chartOptions,
                tooltip
            };
        }
    }
};
</script>